var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChampionsIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 282,
    viewBox: "0 0 423 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5171 217.215C10.9137 218.08 11.3239 218.945 11.7476 219.804L159.951 219.72L157.366 217.135L10.5205 217.218L10.5171 217.215Z",
    fill: "#E9EEF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58941 212.745C8.94187 213.614 9.3045 214.472 9.68072 215.331L155.488 215.248L152.903 212.664L8.58941 212.745Z",
    fill: "#E9EEF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1388 226.155C15.6406 227.023 16.1492 227.885 16.6781 228.74L168.893 228.654L166.308 226.07L15.1388 226.155Z",
    fill: "#E9EEF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7003 221.687C13.1477 222.556 13.6088 223.417 14.0766 224.272L164.418 224.187L161.833 221.603L12.7003 221.687Z",
    fill: "#E9EEF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11383 199.341C4.34072 200.206 4.57779 201.068 4.83184 201.927L142.087 201.849L139.502 199.264L4.12061 199.341L4.11383 199.341Z",
    fill: "#E9EEF3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0272 194.844C3.22014 195.716 3.41988 196.588 3.63658 197.457L137.62 197.381L135.008 194.77L3.03398 194.844L3.0272 194.844Z",
    fill: "#E9EEF3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87957 208.278C7.18791 209.143 7.50645 210.005 7.83855 210.867L151.012 210.786L148.428 208.201L6.87618 208.281L6.87957 208.278Z",
    fill: "#E9EEF3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.14805 190.404C2.29689 191.259 2.45931 192.114 2.6319 192.966L133.12 192.892L130.559 190.331L2.14466 190.4L2.14805 190.404Z",
    fill: "#E9EEF3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.86 230.622C18.4161 231.49 18.9857 232.352 19.5723 233.21L173.361 233.123L170.777 230.539L17.8634 230.625L17.86 230.622Z",
    fill: "#E9EEF3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39457 203.81C5.66219 204.675 5.93997 205.537 6.23135 206.399L146.554 206.32L143.97 203.735L5.39797 203.813L5.39457 203.81Z",
    fill: "#E9EEF3"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9681 244.027C28.7379 244.899 29.5248 245.76 30.3218 246.612L186.758 246.523L184.173 243.939L27.9681 244.027Z",
    fill: "#E9EEF3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3909 270.828C65.3214 271.747 67.2723 272.611 69.247 273.411L152.888 273.364C154.86 272.558 156.816 271.695 158.747 270.775L63.3977 270.828L63.3909 270.828Z",
    fill: "#E9EEF3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.103 279.729L91.0035 279.751C104.248 282.17 117.853 282.166 131.103 279.729Z",
    fill: "#E9EEF3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8139 249.193C33.4549 249.834 34.0994 250.465 34.7506 251.082L187.393 250.996C188.048 250.374 188.693 249.743 189.331 249.104L188.636 248.409L32.1253 248.497C32.356 248.728 32.5832 248.962 32.8139 249.193Z",
    fill: "#E9EEF3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9826 266.358C56.5161 267.259 58.0631 268.121 59.6305 268.941L162.501 268.883C164.069 268.061 165.617 267.198 167.151 266.294L54.9826 266.358Z",
    fill: "#E9EEF3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2039 275.294C76.9726 276.27 79.7754 277.13 82.6019 277.879L139.521 277.847C142.348 277.095 145.152 276.232 147.922 275.253L74.2039 275.294Z",
    fill: "#E9EEF3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0023 261.896C49.288 262.788 50.5873 263.653 51.9002 264.483L170.228 264.413C171.542 263.581 172.846 262.718 174.129 261.822L47.9989 261.893L48.0023 261.896Z",
    fill: "#E9EEF3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8774 235.087C21.4946 235.955 22.1321 236.817 22.7798 237.675L177.825 237.588L175.24 235.003L20.8808 235.09L20.8774 235.087Z",
    fill: "#E9EEF3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2286 239.558C24.917 240.43 25.6224 241.291 26.3414 242.146L182.282 242.058L179.698 239.473L24.2252 239.561L24.2286 239.558Z",
    fill: "#E9EEF3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.44289 185.93C1.56118 186.795 1.68626 187.653 1.82491 188.519L128.675 188.447L126.09 185.863L1.44628 185.933L1.44289 185.93Z",
    fill: "#E9EEF3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0226 257.427C43.1318 258.312 44.2513 259.174 45.3843 260.015L176.761 259.941C177.895 259.105 179.019 258.239 180.126 257.349L42.0226 257.427Z",
    fill: "#E9EEF3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7789 252.97C37.7524 253.855 38.7395 254.713 39.7333 255.557L182.418 255.477C183.416 254.635 184.401 253.772 185.376 252.886L36.7789 252.97Z",
    fill: "#E9EEF3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7881 109.923C18.2209 110.782 17.6673 111.641 17.1238 112.51L52.7238 112.49L50.1392 109.905L18.7881 109.923Z",
    fill: "#E9EEF3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40892 132.281C7.08942 133.143 6.78012 134.002 6.48098 134.871L75.061 134.832L72.4764 132.248L7.41231 132.285L7.40892 132.281Z",
    fill: "#E9EEF3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9765 114.394C15.4669 115.249 14.9676 116.115 14.4818 116.981L57.1882 116.957L54.6036 114.372L15.9765 114.394Z",
    fill: "#E9EEF3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1974 123.336C10.7862 124.195 10.3921 125.057 10.0047 125.926L66.123 125.894L63.5385 123.31L11.194 123.339L11.1974 123.336Z",
    fill: "#E9EEF3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19253 127.814C8.82892 128.673 8.47549 129.535 8.13563 130.404L70.6001 130.369L68.0156 127.784L9.19593 127.818L9.19253 127.814Z",
    fill: "#E9EEF3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4575 118.871C12.9989 119.729 12.5505 120.592 12.119 121.457L61.6603 121.429L59.0757 118.845L13.4575 118.871Z",
    fill: "#E9EEF3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2419 96.5064C28.4643 97.3586 27.7036 98.2211 26.9565 99.0971L39.3164 99.0901L36.7318 96.5056L29.2385 96.5098L29.2419 96.5064Z",
    fill: "#E9EEF3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9199 105.451C21.2882 106.307 20.6768 107.169 20.0723 108.038L48.2604 108.022L45.6758 105.438L21.9199 105.451Z",
    fill: "#E9EEF3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0014 94.6243L34.8566 94.6222L32.9063 92.6719C32.2612 93.317 31.6262 93.9656 31.0014 94.6243Z",
    fill: "#E9EEF3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3886 100.978C24.689 101.833 24.003 102.696 23.3374 103.565L43.7946 103.553L41.2101 100.969L25.3886 100.978Z",
    fill: "#E9EEF3"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35536 145.691C3.15465 146.55 2.96071 147.415 2.78375 148.277L88.4612 148.229L85.8767 145.644L3.36214 145.691L3.35536 145.691Z",
    fill: "#E9EEF3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.4841 168.024C0.463251 168.886 0.449195 169.748 0.445312 170.613L110.788 170.551L108.2 167.963L0.4841 168.024Z",
    fill: "#E9EEF3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86032 136.747C5.58155 137.61 5.31296 138.468 5.05455 139.337L79.5396 139.295L76.955 136.711L5.86371 136.751L5.86032 136.747Z",
    fill: "#E9EEF3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0.687853 163.597C0.633075 164.445 0.585093 165.294 0.547285 166.139L106.315 166.079L103.772 163.535L0.691242 163.593L0.687853 163.597Z",
    fill: "#E9EEF3"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0.453997 172.501C0.46369 173.367 0.486961 174.232 0.520408 175.101L115.268 175.036L112.67 172.438L0.453997 172.501Z",
    fill: "#E9EEF3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0.611137 176.982C0.658159 177.85 0.715353 178.716 0.779345 179.581L119.749 179.514L117.151 176.916L0.611137 176.982Z",
    fill: "#E9EEF3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07913 159.122C0.987008 159.987 0.901663 160.853 0.829907 161.718L101.894 161.661L99.2963 159.063L1.08253 159.118L1.07913 159.122Z",
    fill: "#E9EEF3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5057 141.22C4.26765 142.082 4.03639 142.944 3.8187 143.806L83.9984 143.761L81.4138 141.176L4.5057 141.22Z",
    fill: "#E9EEF3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0.935062 181.464C1.01602 182.326 1.10718 183.192 1.2085 184.054L124.21 183.984L121.625 181.4L0.931663 181.468L0.935062 181.464Z",
    fill: "#E9EEF3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65745 154.639C1.53139 155.504 1.41212 156.37 1.30303 157.239L97.4195 157.184L94.8214 154.586L1.65745 154.639Z",
    fill: "#E9EEF3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41959 150.165C2.25621 151.027 2.0996 151.889 1.95997 152.755L92.9452 152.703L90.3573 150.116L2.42637 150.165L2.41959 150.165Z",
    fill: "#E9EEF3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M367.35 92.1641C391.512 92.1641 411.1 72.5765 411.1 48.4141C411.1 24.2516 391.512 4.66406 367.35 4.66406C343.187 4.66406 323.6 24.2516 323.6 48.4141C323.6 72.5765 343.187 92.1641 367.35 92.1641Z",
    fill: "#E9EEF3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M252.8 216.367H170.8V261.767H252.8V216.367Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8994 231.866C23.1994 232.866 23.3994 233.866 23.6994 234.866H181.799L178.799 231.766H22.8994V231.866Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M169.9 131.367C169.4 132.967 167.6 133.867 166.1 133.267C133.5 121.167 111 86.8672 111 48.9672C111 47.2672 112.4 45.8672 114.1 45.8672H150.2C151.9 45.8672 153.3 47.2672 153.3 48.9672C153.3 50.6672 151.9 52.0672 150.2 52.0672H121.4C119.1 52.0672 117.3 53.9672 117.5 56.1672C120.1 88.5672 140 116.867 168.1 127.467C169.7 128.067 170.6 129.767 170 131.367H169.9Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M228.699 92.0609C228.699 76.9609 240.899 64.7609 255.999 64.7609C240.899 64.7609 228.699 52.5609 228.699 37.4609C228.699 52.5609 216.499 64.7609 201.399 64.7609C216.499 64.7609 228.699 76.9609 228.699 92.0609Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M270.199 27.7656C272.399 27.7656 274.199 29.5656 274.199 31.7656C273.599 106.066 255.899 165.666 211.799 165.666C167.699 165.666 149.999 106.066 149.399 31.7656C149.399 29.5656 151.199 27.7656 153.399 27.7656H270.299H270.199Z",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M170.8 256.161V261.861C170.8 262.961 171.7 263.861 172.8 263.861H250.8C251.9 263.861 252.8 262.961 252.8 261.861V216.461C252.8 215.361 251.9 214.461 250.8 214.461H172.8C171.7 214.461 170.8 215.361 170.8 216.461V230.961C170.8 232.061 169.9 232.961 168.8 232.961H16.5996",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M264.5 263.867H159.1C157.7 263.867 156.5 265.067 156.5 266.467C156.5 267.867 157.7 269.067 159.1 269.067H264.5C265.9 269.067 267.1 267.867 267.1 266.467C267.1 265.067 265.9 263.867 264.5 263.867Z",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M250.8 214.366C228.6 214.366 219.1 165.366 224.6 163.766",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M172.8 214.366C195 214.366 204.5 165.366 199 163.766",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M228.699 92.0609C228.699 76.9609 240.899 64.7609 255.999 64.7609C240.899 64.7609 228.699 52.5609 228.699 37.4609C228.699 52.5609 216.499 64.7609 201.399 64.7609C216.499 64.7609 228.699 76.9609 228.699 92.0609Z",
    fill: "#A3C5EB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M246.9 33.9641C246.9 24.6641 254.5 17.0641 263.8 17.0641C254.5 17.0641 246.9 9.46406 246.9 0.164062C246.9 9.46406 239.3 17.0641 230 17.0641C239.3 17.0641 246.9 24.6641 246.9 33.9641Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M246.9 33.9641C246.9 24.6641 254.5 17.0641 263.8 17.0641C254.5 17.0641 246.9 9.46406 246.9 0.164062C246.9 9.46406 239.3 17.0641 230 17.0641C239.3 17.0641 246.9 24.6641 246.9 33.9641Z",
    fill: "#F39200"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M150 45.4609H110.6C110.6 45.4609 130.9 125.061 168 134.261",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M256 133.961C266 131.461 276.7 123.161 284 113.461H423",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M274.1 45.4609H313.5C313.5 45.4609 309.6 62.2609 301.7 81.2609",
    stroke: "#6F7C87",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampionsIllustration);
export default __webpack_public_path__ + "static/media/champions-illustration.a0628775.svg";
export { ForwardRef as ReactComponent };